import DispatchRequestModel from '@/models/Warehouse/WhDispatchRequest'
import IncludeDispatchRequest from './includes'
import axios from 'axios'
const route = process.env.VUE_APP_API_ROUTE

const fetchDispatchRequest = async function(id) {
    try {
        let dispRequest = await DispatchRequestModel.include(
            IncludeDispatchRequest
        ).find(id)
        return dispRequest
    } catch (error) {
        console.log('Error en fetch', error)
        return error.response.data
    }
}

const updateDispatchRequest = async function(id, data) {
    try {
        let dispatchRequest = await fetchDispatchRequest(id)
        //-
        dispatchRequest.description = data.description
        dispatchRequest.sl_customer_id = data.sl_customer_id
        dispatchRequest.sl_customer_branch_offices_id = data.sl_customer_branch_offices_id
        dispatchRequest.creation_date = data.creation_date
        dispatchRequest.confirm_date = data.dispatched_date
        dispatchRequest.dispatched_date = data.dispatched_date
        dispatchRequest.partial_reception_date = data.partial_reception_date
        dispatchRequest.reception_date = data.reception_date
        dispatchRequest.not_reception_date = data.not_reception_date
        dispatchRequest.pos_sale_id = data.pos_sale_id
        dispatchRequest.g_state_id = data.g_state_id
        //-
        let response = await dispatchRequest.save()
        //-
        return response
    } catch (error) {
        error.response.data
    }
}

const updateConfirmToBillState = async function(id, data) {
    try {
        let dispatchRequest = await fetchDispatchRequest(id)
        //-
        dispatchRequest.g_state_id = data.g_state_id
        //-
        let response = await dispatchRequest.save()
        //-
        return response
    } catch (error) {
        error.response.data
    }
}

const posDispatchRequestToBill = async object => {
    try {
        const response = await axios.put(
            route + '/wh_dispatch_request/bill',
            object
        )
        return response.data
    } catch (error) {
        error.response.data
    }
}

export default {
    fetchDispatchRequest,
    updateDispatchRequest,
    updateConfirmToBillState,
    posDispatchRequestToBill,
}
